module.exports = __webpack_public_path__ + "img/holiday.5d76af4.png";